import { Component, Input } from '@angular/core';
import { ExternalResourceExpiry } from 'app/core/models/external-resource-expiry.model';
import { GridUtilsModule } from 'app/core/modules/grid-utils.module';
import { SharedDynamicModule } from 'app/shared/dynamic/dynamic.module';

@Component({
  selector: 'app-upcoming-expiration',
  standalone: true,
  imports: [GridUtilsModule, SharedDynamicModule],
  templateUrl: './upcoming-expiration.component.html',
})
export class UpcomingExpirationComponent {
  @Input() refExternalResourceExp: ExternalResourceExpiry[] = [];

  constructor() {}
}
